import { useStaticQuery, graphql } from 'gatsby'

export const getEventHeroData = () => {
  const { allStrapiCommonHero } = useStaticQuery(eventHeroDataQuery)
  let eventHeroData = allStrapiCommonHero.nodes[0].Heros.filter(
    value => Object.keys(value).length !== 0
  )
  return eventHeroData[0]
}

const eventHeroDataQuery = graphql`
  query {
    allStrapiCommonHero {
      nodes {
        Heros {
          ... on STRAPI__COMPONENT_SHARED_EVENTS_HERO {
            id
            button {
              id
              name
              url
            }
            description {
              data {
                description
              }
            }
            title
          }
        }
      }
    }
  }
`
